import { UseMutationOptions, useMutation } from "@tanstack/react-query";
import { FieldValues } from "react-hook-form";
import axiosAuth from "../axiosAuth";
import { SECURITY_API } from "./apiRoutes";

const mutateResetPasswordWithOtp = async ({ data }: { data: FieldValues }) => {
  return await axiosAuth.post(`${SECURITY_API}/reset-password-with-otp`, data);
};

const useResetPasswordWithOtpMutation = (
  queryParams?: UseMutationOptions<
    any,
    Error,
    {
      data: FieldValues;
    },
    unknown
  >
) =>
  useMutation({
    mutationFn: mutateResetPasswordWithOtp,
    ...queryParams,
  });

export default useResetPasswordWithOtpMutation;
